import React from "react";
import { Root } from "./style";

export const PageWrapper: React.FC = (props) => {
  return <Root>{props.children}</Root>;
};
